import React, { useState } from 'react';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';

import Label_template_1 from '../../assets/mobile-icons/template_label_1.png';
import Label_template_2 from '../../assets/mobile-icons/template_label_2.png';

const OptionSetting = (props) => {
    const [value, setValue] = useState(props.defaultValue);

    const submitHandler = async (value) => {
        // first, insert new modules if need be.
        let postData = {
            key: props.api,
            category: props.category,
            setting: props.setting,
            value: value
        };
        if (props.groupId !== '0000') {
            postData.groupId = props.groupId;
        }
        SftGlobalData.post('mobileSettings&action=editSettings', postData).then(response => {

        });
    }

    const change = (event) => {
        setValue(event.target.value);
        submitHandler(event.target.value);
    }

    const showDescription = props.description !== "-";

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, py: 1.5 }}>
                <Typography sx={{ fontWeight: 600, minWidth: 0 }}>{props.title}</Typography>
                <FormControl size="small" sx={{ minWidth: 200, flexShrink: 0 }}>
                    <Select native value={value} onChange={change}>
                        {props.children}
                    </Select>
                </FormControl>
            </Box>
            {showDescription && <Typography variant="body2" sx={{ color: 'text.secondary' }}>{props.description}</Typography>}
            {showDescription && <Divider sx={{ mt: 1 }} />}
            {props.setting === "settLabelTemplate" && <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <img src={value === "Template 2" ? Label_template_2 : Label_template_1} alt={props.title} />
            </Box>}
        </Box>
    );
}

export default OptionSetting;
